export function getValueVariant(rank: number): "is-first" | "is-second" | "is-third" | "is-default" {
    if (rank === 1) return "is-first";
    if (rank === 2) return "is-second";
    if (rank === 3) return "is-third";
    return "is-default";
  }